import React from 'react';

export function ContactNotesCard({
  notes,
  notesLoading,
  notesError,
  newNote,
  setNewNote,
  addNote,
  /* deleteNote, */
  expandedNoteIds,
  toggleExpand,
  needsClamp,
  formatDate,
  canAdd
}) {
  return (
    <div className="card h-100">
      <div className="card-header d-flex align-items-center justify-content-between">
        <h5 className="mb-0">Notes</h5>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <label className="form-label">New Note</label>
          <textarea
            className="form-control"
            rows={3}
            placeholder="Write a new note..."
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
          />
          <div className="mt-2 d-flex justify-content-between align-items-center">
            <div className="text-muted small">
              {notesLoading ? 'Loading notes.' : notesError || ''}
            </div>
            <button className="btn btn-primary" onClick={addNote} disabled={!newNote.trim() || !canAdd}>
              Add Note
            </button>
          </div>
        </div>

        {(!notes || notes.length === 0) ? (
          <div className="text-muted">No notes added yet.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-sm align-middle">
              <thead>
                <tr>
                  <th style={{ width: '60%' }}>Note</th>
                  <th style={{ width: '30%' }}>Submitted</th>
                  {/* <th style={{ width: '10%' }}>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {notes.map((n) => {
                  const text = n.text || '';
                  const isExpanded = expandedNoteIds.has(n._id);
                  const isLong = needsClamp(text);
                  const displayText = isLong && !isExpanded ? `${text.slice(0, 120)}...` : text;

                  return (
                    <tr key={n._id}>
                      <td style={{ whiteSpace: 'pre-wrap' }}>
                        <div>{displayText}</div>
                        {isLong && (
                          <button
                            type="button"
                            className="btn btn-link btn-sm p-0 mt-1"
                            onClick={() => toggleExpand(n._id)}
                          >
                            {isExpanded ? 'Read less' : 'Read more.'}
                          </button>
                        )}
                      </td>
                    <td>{formatDate(n.submittedAt || n.createdAt)}</td>
                    {/* <td>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => deleteNote(n._id)}>
                        Delete
                      </button>
                    </td> */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

